import { ParamMap } from '@angular/router';
import {
  FieldExtraConfig,
  FieldInputConfig,
  FieldStyleConfig,
  SearchEngineField,
  SearchEngineFieldType,
} from '@domains/search-engine/search-engine-field';

interface DropdownStyleConfig extends FieldStyleConfig {
  doubleColumn?: boolean;
}

interface DropdownExtraConfig extends FieldExtraConfig {
  value: any;
  orderByAscd?: boolean;
  doubleColumn?: boolean;
}

export class SearchEngineFieldDropdown extends SearchEngineField<string[]> {
  readonly type = SearchEngineFieldType.Dropdown;
  panelIsOpen = false;

  value: any;
  orderByAscd: boolean;
  doubleColumn: boolean;

  constructor(inputConfig: FieldInputConfig, extraConfig: DropdownExtraConfig, inputStyle?: DropdownStyleConfig) {
    super(inputConfig, extraConfig, inputStyle);
    this.value = extraConfig.value;
    this.orderByAscd = extraConfig.orderByAscd ?? false;
    this.doubleColumn = inputStyle?.doubleColumn ?? false;
  }

  valueToQueryParams(value: string[]): { [key: string]: string } {
    const stringifiedValue = value?.join(',');

    if (stringifiedValue && stringifiedValue.length > 0) {
      return {
        [this.name]: stringifiedValue,
      };
    }
    return {};
  }
  paramMapToValue(paramMap: ParamMap): string[] | null {
    return paramMap.get(this.name)?.split(',') ?? null;
  }
}
